import gql from 'graphql-tag'

export const sampleForm = gql`mutation sampleForm($company: String, $name: String!, $attention: String, $address: String!, $city: String!, $state: String!, $zip: String!, $phone: String!,$email: String!, $project: String, $position: String, $comments: String, $skus: [String]!, $quantities: [Int]!, $recaptchaResponse: String!, $intendedUse: String!) {
  sampleForm(input: {company: $company, name: $name, attention: $attention, address: $address, city: $city, state: $state, zip: $zip, phone: $phone, email: $email, project: $project, position: $position, comments: $comments, skus: $skus, quantities: $quantities, recaptchaResponse: $recaptchaResponse, intendedUse: $intendedUse}) {
    success
  }
}`

export const contactForm = gql`mutation contactForm($contactFor: String!, $contactName: String!, $contactCompany: String, $contactCity: String!, $contactState: String!, $contactZip: String!, $contactComments: String!, $contactEmail: String!, $contactPhone: String!, $receiveNewsletter: Boolean!, $recaptchaResponse: String!){
  contactForm(input: {
    contactFor:$contactFor
    contactName: $contactName
    contactCompany: $contactCompany
    contactCity: $contactCity
    contactState: $contactState
    contactZip: $contactZip
    contactComments: $contactComments
    contactEmail: $contactEmail
    contactPhone: $contactPhone
    receiveNewsletter: $receiveNewsletter
    recaptchaResponse: $recaptchaResponse
  }){ 
    success
  }
}`

export const commercialForm = gql`mutation commercialForm($interest: String!, $role: String!, $firstName: String!, $lastName: String!, $company: String!, $state: String!, $phone: String!, $email: String!, $comments: String!, $recaptchaResponse: String!, $cotto: Boolean){
  commercialForm(input: {
    interest:$interest
    role: $role
    firstName: $firstName
    lastName: $lastName
    company: $company
    state: $state
    phone: $phone
    email: $email
    comments: $comments
    recaptchaResponse: $recaptchaResponse
    cotto: $cotto
  }){ 
    success
  }
}`


// WEBPACK FOOTER //
// ./core/vue/graphql/mutations.js